import OrderModal from '../OrderModal/order-modal';

export default OrderModal;